import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '@nutrix/util-config';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(APP_CONFIG);
  const cloned = req.clone({
    headers: req.headers.set('x-xmsbs-tenantkey', config.tenantKey).append('x-xmsbs-apikey', config.apiKey),
  });
  return next(cloned);
};
